import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import InsightsListPage from "@/pages/InsightsListPage";
import InsightDetailPage from "@/pages/InsightDetailPage";
import { I18nProvider } from "@/i18n/I18nContext";

function App() {
  return (
    <I18nProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/insights" element={<InsightsListPage />} />
            <Route path="/insights/:slug" element={<InsightDetailPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </I18nProvider>
  );
}

export default App;
